import Tabs from "@/v2-backoffice-client/components/tabs"
import { useFeatureSurfaceChangesQuery } from "@/v2-backoffice-client/license/changes/license.changes.query"
import { countUndecidedFeatures } from "@/v2-backoffice-client/license/changes/license.changes.utils"
import { LICENSING_VIEW_CHANGES } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's "Feature access" tab trigger. Counts the
// capabilities still waiting on a decision (new in Fusion, free for
// everyone, nobody has said that is intended) so the worklist shows from
// any tab. Apollo dedupes the read against the board's.
function LicenseChangesTabTrigger() {
  const { data, loading } = useFeatureSurfaceChangesQuery()
  const undecidedCount = countUndecidedFeatures(
    data?.getFeatureSurfaceChanges ?? [],
  )

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_CHANGES}
      iconSrc="key"
      isLoading={loading}
      count={undecidedCount}
    >
      Feature access
    </Tabs.Trigger>
  )
}

export default LicenseChangesTabTrigger
